import React, { lazy, Suspense } from "react";
import { BrowserRouter, Route, Switch as Routes } from "react-router-dom";

import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faSpinnerThird } from "@fortawesome/pro-solid-svg-icons";
// import {orange} from "./screens/_util";

const SignIn = lazy(() =>
  import("./screens/SignIn").then((m) => {
    return { default: m.SignIn };
  }),
),
  HomePageLocationReplace = lazy(() =>
    import("./screens/SignIn").then((m) => {
      return { default: m.HomePageLocationReplace };
    }),
  ),
  ResetForm = lazy(() =>
    import("./screens/ResetPassword").then((m) => {
      return { default: m.ResetForm };
    }),
  ),
  DownloadProtectedResource = lazy(() =>
    import("./screens/DownloadProtectedResource").then((m) => {
      return { default: m.DownloadProtectedResource };
    }),
  ),
  PasswordForm = lazy(() =>
    import("./screens/ResetPassword").then((m) => {
      return { default: m.PasswordForm };
    }),
  ),
  Register = lazy(() =>
    import("./screens/Register").then((m) => {
      return { default: m.Register };
    }),
  ),
  Service = lazy(() =>
    import("./screens/Service").then((m) => {
      return { default: m.Service };
    }),
  ),
  ConditionGenderDoB = lazy(() =>
    import("./screens/ConditionJobRoleGenderDoB").then((m) => {
      return { default: m.ConditionGenderDoB };
    }),
  ),
  SLTJobGenderDoB = lazy(() =>
    import("./screens/ConditionJobRoleGenderDoB").then((m) => {
      return { default: m.SLTJobGenderDoB };
    }),
  ),
  SetAccent = lazy(() =>
    import("./screens/Accent").then((m) => {
      return { default: m.SetAccent };
    }),
  ),
  ThanksSigningUp = lazy(() =>
    import("./screens/ThanksSigningUp").then((m) => {
      return { default: m.ThanksSigningUp };
    }),
  ),
  DesignMethod = lazy(() =>
    import("./screens/DesignMethod").then((m) => {
      return { default: m.DesignMethod };
    }),
  ),
  HomePage = lazy(() =>
    import("./screens/HomePage").then((m) => {
      return { default: m.HomePage };
    }),
  ),
  MessageBank = lazy(() =>
    import("./screens/MessageBank").then((m) => {
      return { default: m.MessageBank };
    }),
  ),
  MessageBankRecord = lazy(() =>
    import("./screens/MessageBankRecord").then((m) => {
      return { default: m.MessageBankRecord };
    }),
  ),
  MessageBankMicSelect = lazy(() =>
    import("./screens/MessageBankMicSelect").then((m) => {
      return { default: m.MessageBankMicSelect };
    }),
  ),
  MessageBankExport = lazy(() =>
    import("./screens/MessageBankExport").then((m) => {
      return { default: m.MessageBankExport };
    }),
  ),
  MessageBankImport = lazy(() =>
    import("./screens/MessageBankImport").then((m) => {
      return { default: m.MessageBankImport };
    }),
  ),
  Donors = lazy(() =>
    import("./screens/Donors").then((m) => {
      return { default: m.Donors };
    }),
  ),
  Donor = lazy(() =>
    import("./screens/Donor").then((m) => {
      return { default: m.Donor };
    }),
  ),
  HCPDetails = lazy(() =>
    import("./screens/IsAnyoneHelpingYouHCP").then((m) => {
      return { default: m.IsAnyoneHelpingYouHCP };
    }),
  ),
  ClinicianPatients = lazy(() =>
    import("./screens/ClinicianPatients").then((m) => {
      return { default: m.ClinicianPatients };
    }),
  ),
  Devices = lazy(() =>
    import("./screens/Devices").then((m) => {
      return { default: m.DevicesList };
    }),
  ),
  ConfirmRecordings = lazy(() =>
    import("./screens/ConfirmRecordings").then((m) => {
      return { default: m.ConfirmRecordings };
    }),
  ),
  ConditionAndConsents = lazy(() =>
    import("./screens/ConditionJobRoleGenderDoB").then((m) => {
      return { default: m.ConditionAndConsents };
    }),
  ),
  GenderDoB = lazy(() =>
    import("./screens/ConditionJobRoleGenderDoB").then((m) => {
      return { default: m.GenderDoB };
    }),
  ),
  TransferHCPTHanks = lazy(() =>
    import("./screens/TransferHCPThanks").then((m) => {
      return { default: m.TransferHCPThanks };
    }),
  ),
  PhraseManager = lazy(() =>
    import("./screens/PhraseManager").then((m) => {
      return { default: m.PhraseManager };
    }),
  ),
  // const isDev23 = window.location.hostname === "dev23.speakunique.co.uk";

  App = () => {
    // if (window.document.location.hostname === `localhost`)
    //   localStorage.setItem('token',
    //     'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpZCI6InZlZFhsWUJYIiwiaWF0IjoxNjY5NzE5OTQ4LCJleHAiOjE2Nzc0OTU5NDh9.VbLY7NZEFHGTJPmVJOAVnzaNbbjfs8iRydhi8mw0FQ8');

    return (
      <BrowserRouter basename={"/session"}>
        <Suspense
          fallback={
            <div>
              <div
                style={
                  {
                    // margin: 14,
                    // border: `2px solid ${ orange }`,
                    // borderRadius: 20,
                    // width: "100%",
                    // height: "100%",
                    // minHeight: window.innerHeight - 30,
                  }
                }
              >
                <div
                  className="has-text-centered"
                  style={{
                    paddingTop: "16%",
                    paddingBottom: "16%",
                  }}
                >
                  <img
                    src="https://www.speakunique.co.uk/inc/speakUniqueLogo.png"
                    alt=""
                    title=""
                  />
                </div>
              </div>
            </div>
          }
        >
          <Routes>
            <Route exact path="/" component={HomePage} />
            <Route exact path="/hcpL" component={ClinicianPatients} />
            <Route exact path="/sign-in" component={SignIn} />
            <Route exact path="/forgot" component={ResetForm} />
            <Route path="/reset/:resetToken" component={PasswordForm} />
            <Route
              path="/dld/u:specialId"
              component={DownloadProtectedResource}
            />
            <Route exact path="/register" component={Register} />
            <Route exact path="/service" component={Service} />
            <Route exact path="/mc" component={ConditionGenderDoB} />
            <Route exact path="/mcc" component={ConditionAndConsents} />
            <Route exact path="/dobg" component={GenderDoB} />
            <Route exact path="/hcp" component={HCPDetails} />
            <Route exact path="/anyone-helping-you" component={HCPDetails} />
            <Route exact path="/slt" component={SLTJobGenderDoB} />
            <Route
              exact
              path="/transferHCPTHanks"
              component={TransferHCPTHanks}
            />
            <Route exact path="/accent" component={SetAccent} />
            <Route exact path="/go" component={ThanksSigningUp} />
            <Route exact path="/design" component={DesignMethod} />
            <Route exact path="/donors" component={Donors} />
            <Route exact path="/donor" component={Donor} />
            <Route exact path="/message-bank" component={MessageBank} />
            <Route
              exact
              path="/phrasemanager"
              component={PhraseManager}
            />
            <Route
              exact
              path="/message-bank-record"
              component={MessageBankRecord}
            />
            <Route
              exact
              path="/message-bank-mic-select"
              component={MessageBankMicSelect}
            />
            <Route
              exact
              path="/message-bank-export"
              component={MessageBankExport}
            />
            <Route
              exact
              path="/message-bank-import"
              component={MessageBankImport}
            />

            <Route
              exact
              path="/using-your-voice-speakunique-app-android"
              component={Devices}
            />
            <Route exact path="/devices" component={Devices} />
            <Route exact path="/confirm" component={ConfirmRecordings} />
            <Route path="/:anythingElse" component={HomePageLocationReplace} />
          </Routes>
        </Suspense>
      </BrowserRouter>
    );
  };

export default App;

/*

      <div className="has-text-centered" style={{
          marginTop: "10%"
        }}>
          <FontAwesomeIcon icon={faSpinnerThird}
            className="orange"
            spin={true}
            size="2x"
          />
        </div>


*/
